export default {
  badge: 'Odznak',
  open: 'Otevřít',
  close: 'Zavřít',
  dismiss: 'Zavřít',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Zrušit',
  },
  dataIterator: {
    noResultsText: 'Nenalezeny žádné záznamy',
    loadingText: 'Načítám položky...',
  },
  dataTable: {
    itemsPerPageText: 'Řádků na stránku:',
    ariaLabel: {
      sortDescending: 'Řazeno sestupně.',
      sortAscending: 'Řazeno vzestupně.',
      sortNone: 'Neseřazeno.',
      activateNone: 'Aktivováním vypnete řazení.',
      activateDescending: 'Aktivováním se bude řadit sestupně.',
      activateAscending: 'Aktivováním se bude řadit vzestupně.',
    },
    sortBy: 'Řadit dle',
  },
  dataFooter: {
    itemsPerPageText: 'Položek na stránku:',
    itemsPerPageAll: 'Vše',
    nextPage: 'Další strana',
    prevPage: 'Předchozí strana',
    firstPage: 'První strana',
    lastPage: 'Poslední strana',
    pageText: '{0}-{1} z {2}',
  },
  dateRangeInput: {
    divider: 'do',
  },
  datePicker: {
    itemsSelected: '{0} vybráno',
    range: {
      title: 'Vyberte datumy',
      header: 'Zadejte datumy',
    },
    title: 'Vyberte datum',
    header: 'Zadejte datum',
    input: {
      placeholder: 'Zadejte datum',
    },
    ariaLabel: {
      previousMonth: 'Předchozí měsíc',
      nextMonth: 'Další měsíc',
      selectYear: 'Vyberte rok',
      previousYear: 'Předchozí rok',
      nextYear: 'Další rok',
      selectMonth: 'Vyberte měsíc',
      selectDate: '{0}',
      currentDate: 'Dnes, {0}',
    },
  },
  noDataText: 'Nejsou dostupná žádná data',
  carousel: {
    prev: 'Předchozí obrázek',
    next: 'Další obrázek',
    ariaLabel: {
      delimiter: 'Obrázek {0} z {1}',
    },
  },
  calendar: {
    moreEvents: '{0} dalších',
    today: 'Dnes',
  },
  input: {
    clear: 'Vymazat {0}',
    prependAction: '{0} předřazená akce',
    appendAction: '{0} připojená akce',
    otp: 'Vložte OTP znak {0}',
  },
  fileInput: {
    counter: '{0} souborů',
    counterSize: '{0} souborů ({1} celkem)',
  },
  fileUpload: {
    title: 'Přetáhněte soubory sem',
    divider: 'nebo',
    browse: 'Procházet soubory',
  },
  timePicker: {
    am: 'Dopoledne',
    pm: 'Odpoledne',
    title: 'Vyberte čas',
    hour: 'Hodina',
    minute: 'Minuty',
    second: 'Sekundy',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigace po stránkách',
      next: 'Další strana',
      previous: 'Předchozí strana',
      page: 'Přejít na stránku {0}',
      currentPage: 'Aktuální stránka, stránka {0}',
      first: 'První stránka',
      last: 'Poslední stránka',
    },
  },
  stepper: {
    next: 'Další',
    prev: 'Předchozí',
  },
  rating: {
    ariaLabel: {
      item: 'Hodnocení {0} z {1}',
    },
  },
  loading: 'Načítám...',
  infiniteScroll: {
    loadMore: 'Načíst více',
    empty: 'Žádné další',
  },
  rules: {
    required: 'Toto pole je povinné',
    email: 'Zadejte platný e-mail',
    number: 'Toto pole může obsahovat pouze čísla',
    integer: 'Toto pole může obsahovat pouze celá čísla',
    capital: 'Toto pole může obsahovat pouze velká písmena',
    maxLength: 'Musíte zadat maximálně {0} znaků',
    minLength: 'Musíte zadat minimálně {0} znaků',
    strictLength: 'Délka zadaného pole je neplatná',
    exclude: 'Znak {0} není povolen',
    notEmpty: 'Vyberte alespoň jednu hodnotu',
    pattern: 'Neplatný formát',
  },
  hotkey: {
    then: 'poté',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Šipka nahoru',
    downArrow: 'Šipka dolů',
    leftArrow: 'Šipka vlevo',
    rightArrow: 'Šipka vpravo',
    backspace: 'Backspace',
    space: 'Mezerník',
    plus: 'plus',
    shortcut: 'Klávesová zkratka: {0}',
    or: 'nebo',
  },
  video: {
    play: 'Přehrát',
    pause: 'Pozastavit',
    seek: 'Vyhledat',
    volume: 'Hlasitost',
    showVolume: 'Zobrazit ovládání hlasitosti',
    mute: 'Ztlumit',
    unmute: 'Zrušit ztlumení',
    enterFullscreen: 'Celá obrazovka',
    exitFullscreen: 'Ukončit celou obrazovku',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Vybrat barvu z obrazovky',
      hueSlider: 'Odstín',
      alphaSlider: 'Alfa',
      redInput: 'Červená',
      greenInput: 'Zelená',
      blueInput: 'Modrá',
      alphaInput: 'Alfa',
      hueInput: 'Odstín',
      saturationInput: 'Sytost',
      lightnessInput: 'Světlost',
      hexInput: 'HEX hodnota',
      hexaInput: 'HEX s alfa hodnotou',
      changeFormat: 'Změnit formát barvy',
    },
  },
}
